import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async request => {
    return PostAPI('request', 'UserType/Select');
};
